import PostAttachmentModal from './PostAttachmentModal'

export default PostAttachmentModal
